const {
  isManifestPending,
  isManifestApproved,
  isManifestRejected,
} = require('../utils/approvals-helpers');
const capitalize = require('../utils/capitalize');

module.exports = function (value) {
  if (value.status) return capitalize(value.status);
  if (isManifestRejected(value)) return 'Rejected';
  if (isManifestApproved(value)) return 'Approved';
  if (isManifestPending(value)) return 'Pending';
  return '';
};
